// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkRow_link__36Dw7","center":"LinkRow_center__RMwmf","right":"LinkRow_right__1xz9j"};